<template>
    <div class="upload">
        <a-upload
                :action="imageUploadUrl + '?type=entity'"
                :format="['jpg','png','jpeg','bmp']"
                :beforeUpload="beforeUpload"
                :showUploadList="false"
                @change="handleChange"
                :headers="token">
            <div v-if="imgUrl">
                <img class="img" :src="imgUrl">
            </div>
            <div class="add" v-else>
                <a-icon class="icon" type="plus"/>
                <div class="ant-upload-text">{{$t('global.upload')}}</div>
            </div>
        </a-upload>

        <a-button size="small" style="margin-left:15px" @click="deleteImage" v-if="imgUrl">
            <a-icon type="delete" style="padding-right:4px"/>
            {{$t('global.delete')}}
        </a-button>

        <a-alert style="margin-left:15px" type="info">
            <p slot="description">
                1：{{$t('global.imgTypeTip')}}
                <br/>
                2：{{$t('global.imgSizeTip')}}
            </p>
        </a-alert>
    </div>
</template>
<script>
    import config from '@/config'

    export default {
        props: ['imgUrl'],
        model: {
            event: 'uploadComplete',
            prop: 'imgUrl'
        },
        data() {
            return {
                // uploadedUrl: this.imgUrl == null ? '' : this.imgUrl ,
                imageUploadUrl: config.api.file_upload_url,
                token: {}
            }
        },
        methods: {
            deleteImage() {
                this.imgUrl = ''
                this.$emit('uploadComplete', this.imgUrl)
            },
            handleChange(info) {
                // console.log(info)
                if (info.file.status === 'done' && info.file.response.code === 0) {
                    this.imgUrl = info.file.response.result.imageUrl
                    this.$emit('uploadComplete', this.imgUrl)
                }
            },
            beforeUpload (file) {
                if(file.type.indexOf('image/') == -1){
                    this.$notification["warning"]({
                        message: this.$t('global.tips'),
                        description: this.$t('global.imgTypeTip'),
                    });
                    return false
                }
                let fileSize = file.size
                if(file.size >= 1048576){
                    this.$notification["warning"]({
                        message: this.$t('global.tips'),
                        description: this.$t('global.imgSizeTip'),
                    });
                    return false
                }
                return true
            },
        },
        created() {
            this.token = {Authorization: 'Bearer ' + this.$store.getters.token}
            // console.log(this.imgUrl)
        }
        // beforeDestroy () {
        //   console.log('destroy')
        // }
    }
</script>
<style lang="less" scoped>
    .upload {
        display: flex;
        flex-direction: row;
        // justify-content: center;
        align-items: center;
        .img {
            width: 70px;
            cursor: pointer;
        }
        .add {
            width: 70px;
            height: 98px;
            border: 1px solid #ccc;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: #999;
            cursor: pointer;
            .icon {
                font-size: 20px;
            }
        }
    }
</style>
